import { render, staticRenderFns } from "./CheckboxAttribute.vue?vue&type=template&id=30fb5270&scoped=true"
import script from "./CheckboxAttribute.vue?vue&type=script&lang=js"
export * from "./CheckboxAttribute.vue?vue&type=script&lang=js"
import style0 from "./CheckboxAttribute.vue?vue&type=style&index=0&id=30fb5270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fb5270",
  null
  
)

export default component.exports